import customerInstance from '../instance'

const updateCustomerBillingAddress = (customerNumber, billingAddress) => {
	return customerInstance.put(`/customers/${customerNumber}/billingAddress`, billingAddress)
}

export default updateCustomerBillingAddress
